import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    marginBottom: '0px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },

  title: {
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  root: {
    marginBottom: 16,
    [theme.breakpoints.down('lg')]: {
      marginBottom: 0
    }
  },

  groupContainer: {
    margin: '18px 0px',
    [theme.breakpoints.down('lg')]: {
      marginTop: '0'
    }
  },

  transferName: {
    fontSize: theme.size.base,

    '& strong': {}
  },

  inboxLabel: {
    fontSize: theme.size.base
  },

  inboxSelect: {
    marginTop: 8,
    maxWidth: 320
  },

  buttonSection: {
    display: 'flex',
    justifyContent: 'flex-end',

    [theme.breakpoints.down('lg')]: {
      flexFlow: 'column-reverse',
      gap: 8
    }
  },

  button: {
    width: '164px',
    height: 48,
    marginLeft: 8,

    [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
      width: '100%'
    }
  },

  transferBtn: {
    '&:disabled': {
      color: 'white !important'
    }
  },

  agentContainer: {
    marginTop: 16,
    borderBottom: `1px solid #C6C6C6`,
    paddingBottom: `5px`,
    display: 'flex'
  },

  agentSearchInput: {
    width: '100%',
    fontSize: theme.size.base,
    height: 17,
    border: 'none',
    outline: 'none'
  },

  chip: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '6px 12px',
    background: 'white',
    cursor: 'default',
    fontSize: theme.size.base,
    color: '#1F1F1F',

    '& label': {}
  },

  chipAvatar: {
    width: 24,
    height: 24,
    marginRight: 6
  },

  chipAction: {
    margin: '0px 4px',
    cursor: 'pointer'
  },

  searchResultContainer: {
    listStyle: 'none',
    paddingLeft: '0px',
    maxHeight: 160,
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B64FCD',
      borderRadius: 0
    },

    [theme.breakpoints.down('lg')]: {
      //324px is the sum of the bottom bar, margins and buttons.
      marginBottom: 0,
      maxHeight: 'calc(80svh - 342px)'
    }
  },

  searchResult: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#3C425B',
    flexFlow: 'row',
    padding: '0.5rem 0',
    borderRadius: 8,
    paddingLeft: 6,

    '&:hover': {
      backgroundColor: '#F5F6F8'
    }
  },

  ReAssignLabel: {
    color: '#8F8F8F',
    fontSize: theme.size.sm,
    marginBottom: 12,
    marginTop: 12
  },

  resultsContainer: {
    marginTop: 12
  },

  avatar: {
    width: 36,
    height: 36,
    marginRight: 12
  },

  returnIcon: {
    paddingRight: 16
  },

  spacer: {
    display: 'none',

    [theme.breakpoints.down('lg')]: { flex: 1, display: 'block' }
  }
}))

export default useStyles
